(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.cart-drawer__panel');
  const body = drawer.querySelector('[data-cart-drawer-body]');
  const message = drawer.querySelector('[data-cart-message]');
  const currency = drawer.dataset.currency || 'USD';
  const cartUrl = drawer.dataset.cartUrl || '/cart';
  const allProductsUrl = drawer.dataset.allProductsUrl || '/collections/all';
  const recommendationsUrl = drawer.dataset.recommendationsUrl || '/recommendations/products';
  const recommendationsRail = drawer.querySelector('[data-recommendations-rail]');
  const originalUnitPrice = 3999;
  let lastFocused = null;
  let lastAddedProductId = null;
  let recommendationRequestId = 0;

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency
  }).format(cents / 100);

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

  const showMessage = (text = '') => {
    message.textContent = text;
    message.hidden = !text;
  };

  const updateHeaderCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-trigger]').forEach((node) => {
      node.setAttribute('aria-label', `Cart with ${count} items`);
    });
  };

  const itemMarkup = (item, line) => {
    const originalLinePrice = originalUnitPrice * item.quantity;
    const lineSavings = Math.max(0, originalLinePrice - item.final_line_price);
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : '';
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}&width=260" alt="${escapeHtml(item.product_title)}" width="130" height="163">`
      : '';

    return `<article class="cart-drawer__item">
      <a class="cart-drawer__item-image" href="${escapeHtml(item.url)}">${image}</a>
      <div class="cart-drawer__item-info">
        <div class="cart-drawer__item-top">
          <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          <div class="cart-drawer__item-pricing">
            <strong class="cart-drawer__item-price">${money(item.final_line_price)}</strong>
            <s>${money(originalLinePrice)}</s>
          </div>
        </div>
        ${variant}
        <p class="cart-drawer__item-savings">You save ${money(lineSavings)} · 25% off today</p>
        <div class="cart-drawer__item-bottom">
          <div class="cart-drawer__quantity" aria-label="Quantity for ${escapeHtml(item.product_title)}">
            <button type="button" data-cart-quantity data-line="${line}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-quantity data-line="${line}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">＋</button>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-quantity data-line="${line}" data-quantity="0">Remove</button>
        </div>
      </div>
    </article>`;
  };

  const recommendationCardMarkup = (product) => {
    const imageSource = typeof product.featured_image === 'string'
      ? product.featured_image
      : product.featured_image?.url
        || product.featured_image?.src
        || product.image
        || (typeof product.images?.[0] === 'string'
          ? product.images[0]
          : product.images?.[0]?.src || product.images?.[0]?.url)
        || '';
    const imageUrl = imageSource
      ? `${imageSource}${imageSource.includes('?') ? '&' : '?'}width=700`
      : '';
    const productUrl = product.url || `/products/${product.handle}`;
    const image = imageUrl
      ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(product.title)}" width="700" height="875" loading="lazy">`
      : '';

    const numericPrice = typeof product.price === 'string' && product.price.includes('.')
      ? Math.round(Number(product.price) * 100)
      : Number(product.price || 0);
    const formattedPrice = product.priceText || money(numericPrice);

    return `<article class="riff-rec-card" data-recommended-product-id="${escapeHtml(product.id)}">
      <a class="riff-rec-card__image" href="${escapeHtml(productUrl)}" aria-label="View ${escapeHtml(product.title)}">${image}</a>
      <p class="riff-rec-card__type">${escapeHtml(product.type || product.product_type || 'Graphic T-Shirt')}</p>
      <h3><a href="${escapeHtml(productUrl)}">${escapeHtml(product.title)}</a></h3>
      <div class="riff-rec-card__price"><strong>${formattedPrice}</strong><s>${money(originalUnitPrice)}</s><span class="riff-rec-card__sale-badge">25% OFF TODAY</span></div>
    </article>`;
  };

  const loadBestSellingProductsPage = (page = 1) => {
    window.RiffstitchBestSellingProductPages ||= {};
    if (!window.RiffstitchBestSellingProductPages[page]) {
      const root = window.Shopify?.routes?.root || '/';
      const pageQuery = page > 1 ? `&page=${page}` : '';
      window.RiffstitchBestSellingProductPages[page] = fetch(`${root}collections/all?sort_by=best-selling${pageQuery}`, {
        headers: { Accept: 'text/html' }, credentials: 'same-origin'
      }).then(async (response) => {
        if (!response.ok) return [];
        const documentCopy = new DOMParser().parseFromString(await response.text(), 'text/html');
        return [...documentCopy.querySelectorAll('.product-card[data-product-id]')].map((card) => {
          const link = card.querySelector('.product-card__content p a');
          const image = card.querySelector('.product-card__media img');
          return {
            id: card.dataset.productId,
            title: link?.textContent?.trim() || '',
            url: link?.getAttribute('href') || '',
            image: image?.getAttribute('src') || '',
            type: card.querySelector('.product-card__content h3')?.textContent?.trim() || 'Graphic T-Shirt',
            priceText: card.querySelector('.product-card__pricing strong')?.textContent?.trim() || ''
          };
        }).filter((bestSeller) => bestSeller.id && bestSeller.title && bestSeller.url);
      }).catch(() => []);
    }
    return window.RiffstitchBestSellingProductPages[page];
  };

  const getCartBestSellers = async (excludedProductIds, requestedCount) => {
    const bestSellers = [];
    const usedProductIds = new Set(excludedProductIds);
    let page = 1;

    while (bestSellers.length < requestedCount && page <= 12) {
      const candidates = await loadBestSellingProductsPage(page);
      candidates.forEach((candidate) => {
        const candidateId = String(candidate.id);
        if (bestSellers.length >= requestedCount || usedProductIds.has(candidateId)) return;
        usedProductIds.add(candidateId);
        bestSellers.push(candidate);
      });
      if (candidates.length < 24) break;
      page += 1;
    }

    return bestSellers;
  };

  const showCartRecommendations = async (cartProductIds, relatedProducts, requestId) => {
    const excludedProductIds = new Set(cartProductIds);
    relatedProducts.forEach((product) => excludedProductIds.add(String(product.id)));
    const remainingSlots = Math.max(0, 16 - relatedProducts.length);
    const bestSellers = await getCartBestSellers(excludedProductIds, remainingSlots);
    if (requestId !== recommendationRequestId) return;

    const recommendations = [...relatedProducts, ...bestSellers].slice(0, 16);
    if (recommendations.length) {
      recommendationsRail.innerHTML = recommendations.map(recommendationCardMarkup).join('');
    }
  };

  const loadCartRecommendations = async (cart) => {
    if (!recommendationsRail || !cart.items.length) return;

    const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));
    const referenceProductId = lastAddedProductId && cartProductIds.has(String(lastAddedProductId))
      ? lastAddedProductId
      : cart.items[0]?.product_id;
    if (!referenceProductId) return;

    const requestId = ++recommendationRequestId;
    const endpoint = recommendationsUrl.endsWith('.json') ? recommendationsUrl : `${recommendationsUrl}.json`;
    try {
      const response = await fetch(`${endpoint}?product_id=${encodeURIComponent(referenceProductId)}&limit=10&intent=related`, {
        headers: { Accept: 'application/json' }, credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Recommendation request failed');
      const { products = [] } = await response.json();
      if (requestId !== recommendationRequestId) return;

      const seenProductIds = new Set(cartProductIds);
      const relatedProducts = products.filter((product) => {
        const productId = String(product.id);
        if (seenProductIds.has(productId)) return false;
        seenProductIds.add(productId);
        return true;
      }).slice(0, 16);
      await showCartRecommendations(cartProductIds, relatedProducts, requestId);
    } catch (error) {
      await showCartRecommendations(cartProductIds, [], requestId);
    }
  };

  const render = (cart) => {
    const saleSavings = cart.items.reduce((total, item) => {
      const regularLinePrice = originalUnitPrice * item.quantity;
      const saleLinePrice = Number.isFinite(item.original_line_price)
        ? item.original_line_price
        : item.price * item.quantity;
      return total + Math.max(0, regularLinePrice - saleLinePrice);
    }, 0);
    drawer.querySelector('[data-cart-drawer-count]').textContent = `(${cart.item_count})`;
    drawer.querySelector('[data-cart-footer-count]').textContent = `(${cart.item_count})`;
    drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    drawer.querySelector('[data-cart-savings]').textContent = money(saleSavings);
    updateHeaderCount(cart.item_count);

    const freeShippingThreshold = 7500;
    const remaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const progress = Math.max(0, Math.min(100, (cart.total_price / freeShippingThreshold) * 100));
    drawer.querySelector('[data-cart-progress]').style.width = `${progress}%`;
    drawer.querySelector('[data-cart-milestone]').textContent = remaining > 0
      ? `Add ${money(remaining)} more for free shipping`
      : 'You qualify for free shipping';

    const checkout = drawer.querySelector('.cart-drawer__checkout');
    checkout.classList.toggle('is-disabled', cart.item_count === 0);
    checkout.setAttribute('aria-disabled', cart.item_count === 0 ? 'true' : 'false');

    body.innerHTML = cart.item_count
      ? `<div class="cart-drawer__items">${cart.items.map((item, index) => itemMarkup(item, index + 1)).join('')}</div>`
      : `<div class="cart-drawer__empty">
          <span class="cart-drawer__empty-icon">🛒</span>
          <h3>Your Cart Is Empty</h3>
          <p>Looks like you haven’t found your next favorite tee yet.</p>
          <a href="${escapeHtml(allProductsUrl)}">View Products</a>
        </div>`;

    loadCartRecommendations(cart);
  };

  const getCart = async () => {
    const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load the cart.');
    return response.json();
  };

  const refresh = async () => {
    const cart = await getCart();
    render(cart);
    return cart;
  };

  const open = async () => {
    lastFocused = document.activeElement;
    showMessage();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    panel.focus();
    try { await refresh(); } catch (error) { showMessage(error.message); }
  };

  const close = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (lastFocused?.focus) lastFocused.focus();
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cart-trigger]');
    if (trigger && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      close();
      return;
    }

    const recommendationControl = event.target.closest('[data-recommendations-scroll]');
    if (recommendationControl) {
      const recommendationSection = recommendationControl.closest('[data-recommendations]');
      const recommendationRail = recommendationSection?.querySelector('[data-recommendations-rail]');
      if (recommendationRail) {
        const direction = recommendationControl.dataset.recommendationsScroll === 'previous' ? -1 : 1;
        recommendationRail.scrollBy({ left: recommendationRail.clientWidth * .9 * direction, behavior: 'smooth' });
      }
      return;
    }

    const quantity = event.target.closest('[data-cart-quantity]');
    if (!quantity) return;
    quantity.disabled = true;
    showMessage();
    try {
      const response = await fetch(`${cartUrl}/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(quantity.dataset.line), quantity: Number(quantity.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Could not update this item.');
      render(await response.json());
    } catch (error) {
      showMessage(error.message);
      quantity.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const original = submit?.innerHTML;
    if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
    showMessage();
    try {
      const response = await fetch(`${cartUrl}/add.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add this item.');
      lastAddedProductId = result.product_id || lastAddedProductId;
      await open();
    } catch (error) {
      showMessage(error.message);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
    } finally {
      if (submit) { submit.innerHTML = original; submit.disabled = false; }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  window.RiffstitchCart = { open, close, refresh };
})();
